import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
// import {merge, Observable, of as observableOf} from 'rxjs';
import { SchedulerService } from "../shared/services/scheduler/scheduler.service";
import { DataSource } from '@angular/cdk/table';
import * as moment from "moment";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, PageEvent } from '@angular/material';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray, ValidatorFn } from "@angular/forms";
import { DashboardService } from "../shared/services/dashboard/dashboard.service";
import { CommonService } from '../shared/services/common/common.service';


@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit {
  displayedColumns: string[] = ["navigate", "reportName", "reportPeriod", "CreatedDate", "reportFormat", "nextRun", "action"];
  dataSource = new MatTableDataSource();
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  nextRunData;
  numberOfRecordToBeProcessed = 20;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private schedulerService: SchedulerService, public dialog: MatDialog) {

    this.schedulerService.getAction().subscribe(res => {
      if (['loadScheduled'].includes(res.action)) {
        // this.getScheduledLog(-1, this.numberOfRecordToBeProcessed, 0);
        this.getScheduledLog("desc", this.numberOfRecordToBeProcessed, 1, true);
        this.getScheduledLog("desc", this.numberOfRecordToBeProcessed, 1, false);

      }
    });
  }

  ngOnInit() {
    // this.getScheduledLog(-1, this.numberOfRecordToBeProcessed, 0);
    this.getScheduledLog("desc", this.numberOfRecordToBeProcessed, 1, true);
    this.getScheduledLog("desc", this.numberOfRecordToBeProcessed, 1, false);
  }


  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.isLoadingResults = true;
      this.getScheduledLog("desc", this.numberOfRecordToBeProcessed, 1, false);
    });
  }


  getNextRecord() {
    this.getScheduledLog(this.sort.direction, this.numberOfRecordToBeProcessed, this.paginator.pageIndex, false);
  }

  getNextRun(period, emailTime, firstDay, nextRun) {
    if (nextRun) {
      return nextRun;
    }
    //If scheduled id is not found in scheduled log then take firstday from res
    // else {
    //   //data is in descending order that's why we are using find which will get first record only
    //   let units: moment.unitOfTime.DurationConstructor;
    //   let daysAdd = 1;
      
    //   units = period == "Weekly" ? "week" : period == "Monthly" ? "month" : period == "Yearly" ? "year" : "day";
      
    //   if(typeof period == "object" && period.length != 7){
    //     daysAdd = 7;
    //     firstDay= moment(firstDay).day(period.Daily[0]).format("YYYY-MM-DD"); 
    //   } 
    //   // return moment(firstDay).add(daysAdd, units).add("-04:00").format("YYYY-MM-DD");
    //     return moment(firstDay).add(daysAdd, units).format("YYYY-MM-DD");

    // }
  }

  getPeriod(period, emailTime) {
    let periodName = "Every ";

    //This will be incase of daily only
    if (typeof period == "object") {
      periodName += period.Daily.length == 7 ? "day" : period.Daily.join(" ");
    }
    else {
      let a = period == "Weekly" ? "Week" : period == "Monthly" ? "Month" : period == "Yearly" ? "Year" : "";
      periodName += a;
    }

    return periodName + " at " + emailTime;
  }

  getScheduledLog(sort: string, limit: number, page: number, isCount: boolean) {
    this.schedulerService.getSchedulerLog("createdDate-" + sort, limit, page, isCount)
      .subscribe((r) => {
        this.dataSource.data = r && r.length > 0 ? r : [];
        // this.nextRunData = r && r.NextRun ? r.NextRun : [];
        if(isCount)
          this.resultsLength = r && r.count ? r.count : 0;
        
        this.isLoadingResults = false;
      });
  }


  openSchedulerDialog = (data) => {
    this.dialog.open(SchedulerDialog, {
      data: data,
      height: 'auto',
      width: '800px',
      panelClass: 'full-modal'
    });
  };

  deleteScheduler(sId) {
    this.schedulerService.deleteScheduler(sId).subscribe((r) => {
      this.schedulerService.sendAction("loadScheduled", true);
    });
  }
}



@Component({
  selector: 'scheduler-dialog',
  templateUrl: 'scheduler.dialog.html'
})
export class SchedulerDialog {
  schedulerForm: FormGroup;
  exportDType = [];
  isMailActive = false;
  enumexportDType = [
    { id: "excel", value: "Excel" },
    { id: "pdf", value: "PDF" },
    { id: "csv", value: "CSV" },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<SchedulerDialog>,
    private dashboardService: DashboardService,
    private commonService: CommonService,
    private schedulerService: SchedulerService
  ) {

    // data = this.parseData(data);
    this.createForm(data);
  }


  createForm = (data) => {
    this.exportDType = data.exportType;
    //since request only contains array incase of daily passing only daily obj
    let period;
    let days;


    if (typeof data.period == "object") {
      period = "Daily";
      days = data.period.Daily;
    }
    else {
      period = data.period;
    }

    const temp = this.enumexportDType.map((d) => {
      if (this.exportDType.includes(d.id))
        return new FormControl(true);
      else
        return new FormControl(false);
    });
    // console.log(data.groupIDs);
    // let gpId = data.groupIDs.join(",");
    this.schedulerForm = this.fb.group({
      schedulerID: [data._id],
      dashboardId: [data.dashboardId],
      groupIds: [data.groupIDs.join(",")],
      period: [period],
      firstDay: [data.firstDay],
      days: [days],
      emailTime: [data.emailTime],
      emailTo: [data.emailDetails.to.join(","), Validators.required],
      emailCC: [data.emailDetails.cc.join(",")],
      emailBCC: [data.emailDetails.bcc.join(",")],
      emailSubject: [data.emailDetails.subject],
      reportName: [data.reportName],
      emailBody: [data.emailDetails.body],
      dateFormat: [data.dateFormat],
      exportType: this.fb.array(temp, minSelectedCheckboxes(1)),
      isActive: [data.isActive == 1 ? true : this.isMailActive]
    });
  };

  
  getScheduleFormExportType(){
    return <FormArray> this.schedulerForm.controls['exportType'];
  }


  onSubmitSchedule() {
    if (this.schedulerForm.valid) {
      //Get export type option from user
      let exportTemp = this.schedulerForm.get('exportType').value
        .map((v, i) => v ? this.enumexportDType[i].id : null)
        .filter(v => v !== null);


      let requestBody = this.schedulerForm.value;
      requestBody.exportType = exportTemp;

      //modify isActive value from boolean to 0/1
      if (requestBody.isActive) {
        requestBody.isActive = 1;
      } else {
        requestBody.isActive = 0;
      }


      this.dashboardService.requestMail("scheduler/AddSchedule", requestBody).subscribe((res) => {
        this.commonService.openSnackBar("Mail scheduled Updated", "");
        this.dialogRef.close();
        this.schedulerService.sendAction("loadScheduled", true);

      }, (err) => {
        console.log(err);
        this.commonService.openSnackBar("Failed while updating", "");
        this.dialogRef.close();
      });
    }
  }

}

function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      // get a list of checkbox values (boolean)
      .map(control => control.value)
      // total up the number of checked checkboxes
      .reduce((prev, next) => next ? prev + next : prev, 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/scheduler/scheduler.component.ts